// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__10jty","close-icon-container":"Modal_close-icon-container__2KjLW","scroll-box":"Modal_scroll-box__cRG6M"};